import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class TesteService {
  constructor(private http: HttpClient) {}

  getMunicipios(): Observable<any> {
    return this.http.get<any>('http://localhost/sme/rest/api/municipio');
  }
}
